import { useState, useEffect, useCallback } from "react"

import { isEqual } from "lodash"

export function useCrossTabState(stateKey, defaultValue) {
    const [state, setState] = useState(() => {
        try {
            const item = localStorage.getItem(stateKey)
            return item !== null && item !== "undefined"
                ? JSON.parse(item)
                : defaultValue
        } catch (err) {
            console.error("Failed to parse localStorage value:", err)
            return defaultValue
        }
    })

    useEffect(() => {
        const onReceiveMessage = (e) => {
            if (e.key === stateKey && e.newValue !== null) {
                try {
                    const incoming = JSON.parse(e.newValue)
                    setState((prev) => (isEqual(prev, incoming) ? prev : incoming))
                } catch (err) {
                    console.error("Failed to parse incoming localStorage value:", err)
                }
            }
        }
        window.addEventListener("storage", onReceiveMessage)
        return () => window.removeEventListener("storage", onReceiveMessage)
    }, [stateKey])

    const setCrossTabState = useCallback((newValue) => {
        setState((prevState) => {
            if (isEqual(prevState, newValue)) {
                return prevState
            } else {
                localStorage.setItem(stateKey, JSON.stringify(newValue))
                return newValue
            }
        })
    }, [stateKey])

    return [state, setCrossTabState]
}